var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.CONST.IS_DEV)?_c('div',{staticClass:"envmark"},[_vm._v(" "+_vm._s(_vm.CONST.ENV)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }